import styled from '@emotion/styled';
import Link from 'next/link';
import { colors, spacing } from '../../utils/styleguide';
import { BLOG_PATH } from './blogUtils';

type Props = {
  slug?: string;
  Image?: () => JSX.Element;
  Content?: () => JSX.Element;
  Footer?: () => JSX.Element;
};

const StyledLink = styled(Link)`
  text-decoration: none;
  height: 456px;
  width: 100%;
  overflow: hidden;
  background-color: ${colors.white};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  :hover {
    box-shadow: 0px 5px 12px rgba(0, 26, 82, 0.04), 0px 18px 32px rgba(0, 26, 82, 0.16),
      0px 24px 40px rgba(0, 26, 82, 0.08);
  }
`;

const FooterWrapper = styled.div`
  margin: ${spacing[4]}px;
`;

const PostCardVertical = ({ Image, Content, Footer, slug }: Props) => {
  return (
    <StyledLink href={`${BLOG_PATH}/${slug}`}>
      {Image && <Image />}
      <FooterWrapper>
        {Content && <Content />}
        {Footer && <Footer />}
      </FooterWrapper>
    </StyledLink>
  );
};

export default PostCardVertical;
